import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import text from "../../locales/ru/ru.json";
import "./style.scss";
import Game from "../../store/Game";
import ROUTES from "../../utils/routes";
import BaseIcon from "../BaseIcon";

export default function RulesGame({ children, typeRule, isDemo }) {
  RulesGame.propTypes = {
    children: PropTypes.node,
    typeRule: PropTypes.string,
  };
  const { t } = useTranslation();
  return (
    <div className="rules-wrapper">
      <div className="rules-wrapper__header">
        <div
          className="rules-wrapper__title neon-text"
          data-text={t("rules_game.title")}
        >
          {t("rules_game.title")}
        </div>
      </div>
      <div
        className={[
          "rules-wrapper__rules",
          isDemo && "rules-wrapper__demo-rules",
        ].join(" ")}
      >
        {isDemo ? (
          <div>{t("rules_game.desc")}</div>
        ) : (
          <div className="rules-wrapper__rules__rules-main">
            <div className="rules-wrapper__rules__tip">
              {t("rules_game.tip")}
            </div>
            <ul className="rules-wrapper__rules__list">
              {text.rules_game.rules.map((rule, index) => {
                return (
                  <li key={index} className="rules-wrapper__rules__list__rule">
                    <div className="rules-wrapper__rule-header">
                      <div>{index + 1}</div>
                      <span className="rules-wrapper__rules__list__rule_highlight highlight">
                        {t(`rules_game.rules.${index}.highlight`)}
                      </span>
                    </div>
                    {t(`rules_game.rules.${index}.desc`)}
                  </li>
                );
              })}
            </ul>
            <ul className="rules-wrapper__rules__list rules-wrapper__rules__list--block">
              <li className="rules-wrapper__rules__list__rule">
                <div className="rules-wrapper__rule-header">
                  <div>{5}</div>
                  <span className="rules-wrapper__rules__list__rule_highlight highlight">
                    {t(`rules_game.rule5.highlight`)}
                  </span>
                </div>
                {t(`rules_game.rule5.desc_1`)}
              </li>
              <li className="rules-wrapper__rules__list__rule">
                <ul className="rules-wrapper__rules__sublist">
                  <li>{t(`rules_game.rule5.desc_2`)}</li>
                  <li>{t(`rules_game.rule5.desc_3`)}</li>
                  <li>{t(`rules_game.rule5.desc_4`)}</li>
                </ul>
              </li>
            </ul>
            <div className="rules-exclamation">
              <BaseIcon
                name="exclamation_mark"
                className="rules-exclamation__icon"
              />
              <div className="rules-exclamation__text">
                <BaseIcon
                  name="exclamation_mark"
                  iconWrapperStyle="rules-exclamation__icon--wrap"
                />
                {t(`rules_game.exclamation`)}
              </div>
              <BaseIcon
                name="exclamation_mark"
                className="rules-exclamation__icon"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
